import React from 'react';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UndoIcon from '@mui/icons-material/Undo';
import ContentEditableText from './ContentEditableText';

export default function EditableInlineField({
    blockClassName,
    containerSx,
    typographyVariant,
    typographyColor,
    typographyComponent = 'div',
    typographySx,
    label,
    labelSx,
    contentSx,
    contentComponent = 'span',
    value,
    fallbackValue = '',
    canEdit,
    isEdited,
    onChange,
    onRevert,
    revertTooltip,
    controlsClassName,
    controlsMl = 0,
    controlsSpacing = 0,
    indicatorMl = 1,
}) {
    const hoverSelector = blockClassName ? `.${blockClassName}:hover &` : '&';

    return (
        <Box sx={containerSx} className={blockClassName}>
            <Typography
                variant={typographyVariant}
                color={typographyColor}
                component={typographyComponent}
                sx={typographySx}
            >
                {label && (
                    <Box component="span" sx={labelSx}>
                        {label}
                    </Box>
                )}

                <ContentEditableText
                    component={contentComponent}
                    sx={[{ outline: 'none' }, contentSx]}
                    canEdit={canEdit}
                    value={value || fallbackValue}
                    onChange={onChange}
                />

                {canEdit && isEdited && (
                    <Box
                        component="span"
                        sx={{
                            display: 'inline-flex',
                            verticalAlign: 'middle',
                            ml: indicatorMl,
                        }}
                    >
                        <EditNoteIcon fontSize="small" color="action" />
                    </Box>
                )}

                <Stack
                    className={controlsClassName}
                    component="span"
                    direction="row"
                    spacing={controlsSpacing}
                    sx={{
                        display: canEdit ? 'inline-flex' : 'none',
                        verticalAlign: 'middle',
                        ml: controlsMl,
                        opacity: 0,
                        transition: 'opacity 0.15s ease',
                        [hoverSelector]: {
                            opacity: isEdited ? 1 : 0,
                        },
                    }}
                >
                    {isEdited && (
                        <Tooltip title={revertTooltip}>
                            <IconButton
                                size="small"
                                color="error"
                                disabled={!canEdit}
                                onClick={onRevert}
                            >
                                <UndoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Stack>
            </Typography>
        </Box>
    );
}